/** Canonical prize pipeline values (Sponsor Management). */
const CANONICAL_PRIZE_STATUSES = ['assumed', 'confirmed', 'received', 'printed', 'awarded'];
const CANONICAL_SET = new Set(CANONICAL_PRIZE_STATUSES);

/**
 * Normalize raw prize status strings to a canonical value (same rules as Sponsor Management).
 */
export function normalizePrizeStatus(raw) {
  const v = String(raw || '').trim().toLowerCase();
  if (!v) return 'assumed';
  if (v.includes('award')) return 'awarded';
  if (v.includes('print')) return 'printed';
  if (v.includes('receiv')) return 'received';
  if (v.includes('confirm')) return 'confirmed';
  if (v.includes('assum') || v.includes('order') || v.includes('pending') || v.includes('todo')) return 'assumed';
  if (CANONICAL_SET.has(v)) return v;
  return 'assumed';
}

/** Statuses shown on the public "What can I win?" page (excludes assumed / placeholders). */
export function isPublicWhatCanIWinPrizeStatus(raw) {
  const n = normalizePrizeStatus(raw);
  return n === 'confirmed' || n === 'received' || n === 'printed' || n === 'awarded';
}
